define("shared/components/shared/social-identity", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/array", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _array, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/array",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cSS--setWrapper">
    <div class={{concat-classes "cSS--set__identity"}}>
      <span class="cSS--set__name {{if this.showLabelError 'cSS--set__name--danger'}}">
        {{#if @socialIdentity.displayName}}
          {{@socialIdentity.displayName}}
        {{else}}
          {{t "account.groups.table.social_set_name" index=(rebase-indexed-number this.index)}}
        {{/if}}
      </span>
      {{#if this.hasCreatorProfile}}
        <div class="cSS--set__label u--text--sm">
          {{t "account.creator_profile.title"}}
          <span class="u--cursor" {{on "click" this.toggleCreatorProfileModal}}>
            {{svg-jar "info" class="o--icon--sm cSS--set__labelIcon"}}
          </span>
        </div>
      {{/if}}
    </div>
    <div
      class={{concat-classes
        "at--addProfileHighTrafficV1__addProfile cSS--set"
        (if this.showLabelError "cSS--set--danger")
        (if this.showDetails "cSS--set--block")
        (if this.hasSelectedProfile "has--selected--profile")
        (concat "has--selected--" @selectedSocialProfileType)
        (if @editable "cSS--set--dashed cSS--set--block")
        (if @isDisabled "u--mute u--text--strike")
      }}
      ...attributes
    >
      {{#if @editable}}
        <div class="cSS--set__count" draggable="true">
          {{svg-jar "move" class="o--icon--sm"}}
        </div>
      {{else}}
        {{#if @newIdentity}}
          <div class="cSS--set__count" draggable="true">
            {{svg-jar "add" class="o--icon--sm"}}
          </div>
        {{/if}}
      {{/if}}
  
      <DragSortList
        @additionalArgs={{hash socialIdentity=@socialIdentity}}
        @childClass={{if @editable "cSS--set__item cSS--set__item--dashed"}}
        @determineForeignPositionAction={{action "determineForeignPosition"}}
        @dragEndAction={{perform this.tradeSocialProfile}}
        @draggingEnabled={{@editable}}
        @isHorizontal={{true}}
        @items={{this.filteredProfiles}}
        class="individualList cSS--set__list qa--social_set_modal"
        data-test-id="social set"
        as |socialProfile|
      >
        {{#if socialProfile.hasProfile}}
          <Shared::SocialIdentity::Item
            @lockProfile={{@editing}}
            @selectable={{@editable}}
            @socialProfile={{socialProfile.profile}}
          />
        {{else}}
          <Shared::SocialIdentity::PlaceholderItem
            @platform={{socialProfile.profileType}}
            @properties={{hash platform=socialProfile.profileType socialIdentity=@socialIdentity}}
            @selectable={{@editing}}
            @toggleSelect={{@toggleSelect}}
          />
        {{/if}}
      </DragSortList>
  
      <Shared::Mavely::LogoBadge @socialIdentity={{@socialIdentity}} />
  
      {{yield}}
  
      {{#if (and @showDetails (not this.hasErrors))}}
        <Shared::Ui::Button
          @class="cSS--set__status"
          @onClick={{fn @clickedDetails @socialIdentity.id}}
          @variant="actionLink"
        >
          {{t "shared_words.details"}}
          {{svg-jar "nav-right" class="o--icon--sm u--m__l__xs"}}
        </Shared::Ui::Button>
      {{/if}}
    </div>
    {{#if this.hasSocialSetError}}
      <div>
        <Shared::Ui::Button
          @class="u--text--danger"
          @onClick={{fn @clickedDetails @socialIdentity.id}}
          @variant="actionLink"
          data-test-id="social set error message"
        >
          {{svg-jar "info" class="o--icon--sm u--m__l__xs"}}
          {{t "shared_phrases.social_sets.connection_expired"}}
        </Shared::Ui::Button>
      </div>
    {{/if}}
  </div>
  
  {{#if this.showCreatorProfileModal}}
    <Shared::CreatorProfileModal @close={{toggle-action "showCreatorProfileModal" this}} />
  {{/if}}
  */
  {
    "id": "5ClbJEEK",
    "block": "[[[10,0],[14,0,\"cSS--setWrapper\"],[12],[1,\"\\n  \"],[10,0],[15,0,[28,[37,0],[\"cSS--set__identity\"],null]],[12],[1,\"\\n    \"],[10,1],[15,0,[29,[\"cSS--set__name \",[52,[30,0,[\"showLabelError\"]],\"cSS--set__name--danger\"]]]],[12],[1,\"\\n\"],[41,[30,1,[\"displayName\"]],[[[1,\"        \"],[1,[30,1,[\"displayName\"]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,2],[\"account.groups.table.social_set_name\"],[[\"index\"],[[28,[37,3],[[30,0,[\"index\"]]],null]]]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasCreatorProfile\"]],[[[1,\"      \"],[10,0],[14,0,\"cSS--set__label u--text--sm\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.creator_profile.title\"],null]],[1,\"\\n        \"],[11,1],[24,0,\"u--cursor\"],[4,[38,4],[\"click\",[30,0,[\"toggleCreatorProfileModal\"]]],null],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"info\"],[[\"class\"],[\"o--icon--sm cSS--set__labelIcon\"]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n  \"],[11,0],[16,0,[28,[37,0],[\"at--addProfileHighTrafficV1__addProfile cSS--set\",[52,[30,0,[\"showLabelError\"]],\"cSS--set--danger\"],[52,[30,0,[\"showDetails\"]],\"cSS--set--block\"],[52,[30,0,[\"hasSelectedProfile\"]],\"has--selected--profile\"],[28,[37,6],[\"has--selected--\",[30,2]],null],[52,[30,3],\"cSS--set--dashed cSS--set--block\"],[52,[30,4],\"u--mute u--text--strike\"]],null]],[17,5],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[10,0],[14,0,\"cSS--set__count\"],[14,\"draggable\",\"true\"],[12],[1,\"\\n        \"],[1,[28,[35,5],[\"move\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,6],[[[1,\"        \"],[10,0],[14,0,\"cSS--set__count\"],[14,\"draggable\",\"true\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[\"add\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"\\n    \"],[8,[39,7],[[24,0,\"individualList cSS--set__list qa--social_set_modal\"],[24,\"data-test-id\",\"social set\"]],[[\"@additionalArgs\",\"@childClass\",\"@determineForeignPositionAction\",\"@dragEndAction\",\"@draggingEnabled\",\"@isHorizontal\",\"@items\"],[[28,[37,8],null,[[\"socialIdentity\"],[[30,1]]]],[52,[30,3],\"cSS--set__item cSS--set__item--dashed\"],[28,[37,9],[[30,0],\"determineForeignPosition\"],null],[28,[37,10],[[30,0,[\"tradeSocialProfile\"]]],null],[30,3],true,[30,0,[\"filteredProfiles\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,7,[\"hasProfile\"]],[[[1,\"        \"],[8,[39,11],null,[[\"@lockProfile\",\"@selectable\",\"@socialProfile\"],[[30,8],[30,3],[30,7,[\"profile\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,12],null,[[\"@platform\",\"@properties\",\"@selectable\",\"@toggleSelect\"],[[30,7,[\"profileType\"]],[28,[37,8],null,[[\"platform\",\"socialIdentity\"],[[30,7,[\"profileType\"]],[30,1]]]],[30,8],[30,9]]],null],[1,\"\\n\"]],[]]],[1,\"    \"]],[7]]]]],[1,\"\\n\\n    \"],[8,[39,13],null,[[\"@socialIdentity\"],[[30,1]]],null],[1,\"\\n\\n    \"],[18,12,null],[1,\"\\n\\n\"],[41,[28,[37,15],[[30,10],[28,[37,16],[[30,0,[\"hasErrors\"]]],null]],null],[[[1,\"      \"],[8,[39,17],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"cSS--set__status\",[28,[37,18],[[30,11],[30,1,[\"id\"]]],null],\"actionLink\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,2],[\"shared_words.details\"],null]],[1,\"\\n        \"],[1,[28,[35,5],[\"nav-right\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasSocialSetError\"]],[[[1,\"    \"],[10,0],[12],[1,\"\\n      \"],[8,[39,17],[[24,\"data-test-id\",\"social set error message\"]],[[\"@class\",\"@onClick\",\"@variant\"],[\"u--text--danger\",[28,[37,18],[[30,11],[30,1,[\"id\"]]],null],\"actionLink\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,5],[\"info\"],[[\"class\"],[\"o--icon--sm u--m__l__xs\"]]]],[1,\"\\n        \"],[1,[28,[35,2],[\"shared_phrases.social_sets.connection_expired\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showCreatorProfileModal\"]],[[[1,\"  \"],[8,[39,19],null,[[\"@close\"],[[28,[37,20],[\"showCreatorProfileModal\",[30,0]],null]]],null],[1,\"\\n\"]],[]],null]],[\"@socialIdentity\",\"@selectedSocialProfileType\",\"@editable\",\"@isDisabled\",\"&attrs\",\"@newIdentity\",\"socialProfile\",\"@editing\",\"@toggleSelect\",\"@showDetails\",\"@clickedDetails\",\"&default\"],false,[\"concat-classes\",\"if\",\"t\",\"rebase-indexed-number\",\"on\",\"svg-jar\",\"concat\",\"drag-sort-list\",\"hash\",\"action\",\"perform\",\"shared/social-identity/item\",\"shared/social-identity/placeholder-item\",\"shared/mavely/logo-badge\",\"yield\",\"and\",\"not\",\"shared/ui/button\",\"fn\",\"shared/creator-profile-modal\",\"toggle-action\"]]",
    "moduleName": "shared/components/shared/social-identity.hbs",
    "isStrictMode": false
  });
  /**
   * @class SocialIdentity
   * /
   * @extends Component
   *
   * This component renders a social identity (aka set), which is defined as a group of
   * each social platform that we support (Facebook, Instagram, Twitter, Pinterest, LinkedIn, Tiktok, YouTube, Threads, Snapchat).
   * Social identities are a model on the backend that has a hasMany relationship to profiles that gets loaded in through
   * this component. This component leans quite heavily on the ember-drag-sort addon (https://github.com/kaliber5/ember-drag-sort)
   * and it's suggested you read the documentation there before working on it.
   *
   * Structurally this component is reliant on the SocialIdentity::Item and SocialIdentity:PlaceholderItem components as it
   * loads either one of those in for each social profile as necessary.
   *
   * Required Arguments:
   * - index (Integer) The index of the item within the group, used to display the number within each group.
   *
   * Optional Arguments:
   * - socialIdentity (SocialIdentity|Object) An identity that is used to display the relevant profiles.
   * - showDetails (Boolean) This boolean controls whether or not to show the details/error message at the right side of the component.
   * - clickedDetails (Function) Function to perform when clicking on the details or error message when they're displayed.
   * - editable (Boolean) Controls the styling in when in an editable state (adds red border). Used in the /trade version.
   * - adding (Boolean) Controls the styling when in the adding state (disables profiles, adds button to new). Used in the /social_profiles/new version.
   * - selectedSocialIdentity (String) Applies CSS class at top of element based on the profile type.
   * - selectedSocialProfileType (String) Applies CSS class at top of element based on the profile type.
   *
   * Examples:
   *
   * Simple Usage:
   * ```
   *  <Shared::SocialIdentity />
   * ```
   *
   * Inline Usage with all options:
   * ```
   *  <Shared::SocialIdentity
   *    @socialIdentity={{identity}}
   *    @showDetails={{true}}
   *    @index={{1}}
   *    @clickedDetails={{action 'scrollTo'}}
   *  />
   * ```
   *
   */
  let SocialIdentityComponent = _exports.default = (_class = class SocialIdentityComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "showCreatorProfileModal", _descriptor2, this);
      /**
       * Default identity for when using this outside the usual context (displaying what a set is) that doesn't contain an actual identity.
       *
       * @property socialIdentity
       */
      _defineProperty(this, "defaultSocialIdentity", _object.default.create({
        id: 0,
        socialProfiles: []
      }));
      /**
       * Default index set to zero.
       *
       * @property index
       */
      _defineProperty(this, "defaultIndex", 0);
      _defineProperty(this, "tradeSocialProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (_ref) {
          var _this = this;
          let {
            sourceList,
            sourceIndex,
            sourceArgs,
            targetArgs,
            targetIndex,
            targetList
          } = _ref;
          return function* () {
            if (!targetArgs.socialIdentity) {
              return;
            }
            const incomingProfile = sourceList.objectAt(sourceIndex);
            const outgoingProfile = targetList.objectAt(sourceIndex);
            if (_this.args.trackProfileTrade) {
              const didMoveProfileBetweenGroups = sourceArgs.socialIdentity.group.get('id') !== targetArgs.socialIdentity.group.get('id');
              const didConfirmTrade = yield _this.args.trackProfileTrade.perform(incomingProfile, didMoveProfileBetweenGroups, outgoingProfile);
              if (!didConfirmTrade) {
                return;
              }
            }
            yield sourceList.removeAt(sourceIndex);
            targetList.removeAt(sourceIndex);
            sourceList.insertAt(sourceIndex, outgoingProfile);
            targetList.insertAt(targetIndex, incomingProfile);
            sourceArgs.socialIdentity.set('temporaryProfiles', sourceList);
            targetArgs.socialIdentity.set('temporaryProfiles', targetList);
          }();
        }
      }), null, "tradeSocialProfile", "drop"));
    }
    get account() {
      return this.auth.currentAccount;
    }
    get rolloutSnapchat() {
      return this.account.rolloutSnapchat;
    }
    get hasSocialSetError() {
      return this.hasErrors && !this.args.editable && !this.args.adding;
    }
    get index() {
      return this.args.index || this.defaultIndex;
    }
    get socialIdentity() {
      return this.args.socialIdentity || this.defaultSocialIdentity;
    }
    get hasSelectedProfile() {
      return this.args.selectedSocialIdentity === this.socialIdentity;
    }

    /**
     * Returns true for entire set if at least one of the child profiles has an error. Used to display an error message
     * and modify styling of component.
     *
     * @property hasErrors
     */
    get hasErrors() {
      const profilesWithErrors = this.socialIdentity.socialProfiles.filterBy('hasError');
      if (this.auth.currentAccount.rolloutTwitterSunset) {
        return !(0, _utils.isEmpty)(profilesWithErrors.filter(profile => !profile.isTwitter));
      }
      return !(0, _utils.isEmpty)(profilesWithErrors);
    }

    /**
     * Returns if the set should show error classes on the social set label.
     *
     * @property showLabelError
     */
    get showLabelError() {
      return this.hasErrors && !this.args.editable && !this.args.adding;
    }

    /**
     * Returns the first instagram profile within the social profiles (this originally comes from an identity
     * so there can be one maximum)
     *
     * @property instagramProfile
     */
    get instagramProfile() {
      return this.socialProfiles.filter(profile => profile.isInstagram).objectAt(0);
    }

    /**
     * Returns whether or not there's an Instagram profile within the social set.
     *
     * @property hasInstagramProfile
     */
    get hasInstagramProfile() {
      return !(0, _utils.isEmpty)(this.instagramProfile);
    }

    /**
     * Returns the first facebook profile within the social profiles (this originally comes from an identity
     * so there can be one maximum)
     *
     * @property facebookProfile
     */
    get facebookProfile() {
      return this.socialProfiles.filter(profile => profile.isFacebook).objectAt(0);
    }

    /**
     * Returns whether or not there's a facebook profile within the social set.
     *
     * @property hasFacebookProfile
     */
    get hasFacebookProfile() {
      return !(0, _utils.isEmpty)(this.facebookProfile);
    }

    /**
     * Returns the first twitter profile within the social profiles (this originally comes from an identity
     * so there can be one maximum)
     *
     * @property facebookProfile
     */
    get twitterProfile() {
      return this.socialProfiles.filter(profile => profile.isTwitter).objectAt(0);
    }

    /**
     * Returns whether or not there's a twitter profile within the social set.
     *
     * @property hasTwitterProfile
     */
    get hasTwitterProfile() {
      return !(0, _utils.isEmpty)(this.twitterProfile);
    }

    /**
     * Returns the first pinterest profile within the social profiles (this originally comes from an identity
     * so there can be one maximum)
     *
     * @property pinterestProfile
     */
    get pinterestProfile() {
      return this.socialProfiles.filter(profile => profile.isPinterest).objectAt(0);
    }

    /**
     * Returns whether or not there's a pinterest profile within the social set.
     *
     * @property hasPinterestProfile
     */
    get hasPinterestProfile() {
      return !(0, _utils.isEmpty)(this.pinterestProfile);
    }

    /**
     * Returns the first linkedin profile within the social profiles (this originally comes from an identity
     * so there can be one maximum)
     *
     * @property linkedinProfile
     */
    get linkedinProfile() {
      return this.socialProfiles.filter(profile => profile.isLinkedin).objectAt(0);
    }

    /**
     * Returns whether or not there's a linkedin profile within the social set.
     *
     * @property hasLinkedinProfile
     */
    get hasLinkedinProfile() {
      return !(0, _utils.isEmpty)(this.linkedinProfile);
    }

    /**
     * Returns the first tiktok profile within the social profiles (this originally comes from an identity
     * so there can be one maximum)
     *
     * @property tiktokProfile
     */
    get tiktokProfile() {
      return this.socialProfiles.filter(profile => profile.isTiktok).objectAt(0);
    }

    /**
     * Returns whether or not there's a tiktok profile within the social set.
     *
     * @property hasTiktokProfile
     */
    get hasTiktokProfile() {
      return !(0, _utils.isEmpty)(this.tiktokProfile);
    }

    /**
     * Returns the first youtube profile within the social profiles (this originally comes from an identity
     * so there can be one maximum)
     *
     * @property youtubeProfile
     */
    get youtubeProfile() {
      return this.socialProfiles.filter(profile => profile.isYoutube).objectAt(0);
    }

    /**
     * Returns whether or not there's a youtube profile within the social set.
     *
     * @property hasYoutubeProfile
     */
    get hasYoutubeProfile() {
      return !(0, _utils.isEmpty)(this.youtubeProfile);
    }

    /**
     * Returns the first threads profile within the social profiles (this originally comes from an identity
     * so there can be one maximum)
     *
     * @property threadsProfile
     */
    get threadsProfile() {
      return this.socialProfiles.filter(profile => profile.isThreads).objectAt(0);
    }

    /**
     * Returns whether or not there's a threads profile within the social set.
     *
     * @property hasThreadsProfile
     */
    get hasThreadsProfile() {
      return !(0, _utils.isEmpty)(this.threadsProfile);
    }

    /**
     * Returns the first snapchat profile within the social profiles (this originally comes from an identity
     * so there can be one maximum)
     *
     * @property snapchatProfile
     */
    get snapchatProfile() {
      return this.socialProfiles.filter(profile => profile.isSnapchat).objectAt(0);
    }

    /**
     * Returns whether or not there's a snapchat profile within the social set.
     *
     * @property hasSnapchatProfile
     */
    get hasSnapchatProfile() {
      return !(0, _utils.isEmpty)(this.snapchatProfile);
    }

    /**
     * Returns an array of profile objects in this order: IG, FB, TW, PIN, [ TK, LI, YT ]).
     * These objects are used to display either the social-identity/item (if they exist) or the social-identity/placeholder
     * if not.
     *
     * @property profiles
     */
    get profiles() {
      const profiles = (0, _array.A)([_object.default.create({
        profileType: _constants.SOCIAL_PROFILE_CODES.INSTAGRAM,
        hasProfile: this.hasInstagramProfile,
        profile: this.instagramProfile
      }), _object.default.create({
        profileType: _constants.SOCIAL_PROFILE_CODES.FACEBOOK,
        hasProfile: this.hasFacebookProfile,
        profile: this.facebookProfile
      })]);
      if (!this.account.rolloutTwitterSunset) {
        profiles.push(_object.default.create({
          profileType: _constants.SOCIAL_PROFILE_CODES.TWITTER,
          hasProfile: this.hasTwitterProfile,
          profile: this.twitterProfile
        }));
      }
      profiles.push(_object.default.create({
        profileType: _constants.SOCIAL_PROFILE_CODES.PINTEREST,
        hasProfile: this.hasPinterestProfile,
        profile: this.pinterestProfile
      }), _object.default.create({
        profileType: _constants.SOCIAL_PROFILE_CODES.THREADS,
        hasProfile: this.hasThreadsProfile,
        profile: this.threadsProfile
      }));
      if (this.account.canTiktok) {
        profiles.push(_object.default.create({
          profileType: _constants.SOCIAL_PROFILE_CODES.TIKTOK,
          hasProfile: this.hasTiktokProfile,
          profile: this.tiktokProfile
        }));
      }
      if (this.account.canAccessLinkedin) {
        profiles.push(_object.default.create({
          profileType: _constants.SOCIAL_PROFILE_CODES.LINKEDIN,
          hasProfile: this.hasLinkedinProfile,
          profile: this.linkedinProfile
        }));
      }
      if (this.account.rolloutYoutubeShorts) {
        profiles.push(_object.default.create({
          profileType: _constants.SOCIAL_PROFILE_CODES.YOUTUBE,
          hasProfile: this.hasYoutubeProfile,
          profile: this.youtubeProfile
        }));
      }
      if (this.account.rolloutSnapchat) {
        profiles.push(_object.default.create({
          profileType: _constants.SOCIAL_PROFILE_CODES.SNAPCHAT,
          hasProfile: this.hasSnapchatProfile,
          profile: this.snapchatProfile
        }));
      }
      return profiles;
    }

    /**
     * Returns filtered profiles array excluding Twitter placeholders (Twitter profiles without actual profiles)
     * while still showing Twitter profiles when they exist.
     *
     * @property filteredProfiles
     */
    get filteredProfiles() {
      return this.profiles.filter(profile => {
        if (profile.hasProfile) {
          return true;
        }
        if (profile.profileType === _constants.SOCIAL_PROFILE_CODES.TWITTER) {
          return false;
        }
        return true;
      });
    }

    /**
     * By default turns the social profiles that are attached to the social identity. Can switch to the "temporaryProfiles"
     * that are assigned to the social identity for display if they're set. We use this second behaviour in the /trade route
     * where users are able to drag social profiles between sets before they save them.
     *
     * @property socialProfiles
     */
    get socialProfiles() {
      if ('temporaryProfiles' in this.socialIdentity && this.socialIdentity.temporaryProfiles) {
        return this.socialIdentity.temporaryProfiles.map(tempProfile => tempProfile.profile ? tempProfile.profile : _object.default.create());
      }
      return this.socialIdentity.socialProfiles;
    }

    /**
     * Returns whether or not the social identity has a creator profile (i.e. an influencerId)
     *
     * @property hasCreatorProfile
     */
    get hasCreatorProfile() {
      return 'influencerId' in this.socialIdentity ? !(0, _utils.isEmpty)(this.socialIdentity.influencerId) : false;
    }

    /**
     * Toggle the creator profile modal.
     *
     * @property toggleCreatorProfileModal
     */
    toggleCreatorProfileModal() {
      this.showCreatorProfileModal = !this.showCreatorProfileModal;
    }

    /**
     * Function that gets passed into the ember-drag-sort component that allows us to limit where items are allowed to be
     * dragged to.
     *
     * @method determineForeignPosition
     */
    determineForeignPosition(_ref2) {
      let {
        draggedItem,
        items
      } = _ref2;
      const {
        profileType
      } = draggedItem;
      const slotAvailable = (0, _utils.isEmpty)(items.filter(item => item.hasProfile == true && item.profileType == profileType));
      if (slotAvailable) {
        switch (draggedItem.profileType) {
          case 'ig':
            return 0;
          case 'fb':
            return 1;
          case 'tw':
            return 2;
          case 'pin':
            return 3;
          case 'tk':
            return 4;
          case 'li':
            return 5;
          case 'yt':
            return 6;
          case 'th':
            return 7;
          case 'sc':
            return 8;
        }
      } else {
        return null;
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showCreatorProfileModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleCreatorProfileModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCreatorProfileModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "determineForeignPosition", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "determineForeignPosition"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialIdentityComponent);
});